import React, { JSX } from 'react';

import { IInventoryRule } from '~/src/dash/apiV2/inventory-rules/inventoryRules';
import { IconV2 } from '~/src/dash/components/icons/IconV2';
import { Col, Cols, Row, Rows, spacing, Text } from '~/src/dash/publicaUI';
import { formatCommaSeparated } from '~/src/dash/utils/string';
import { ColKeyValuePair } from '~/src/dash/views/inventory-rules-v2/Rules/InventoryRulesList/InventoryRuleDrawer/ColKeyValuePair';

interface IProps {
  rule: IInventoryRule;
}

export const InventoryRuleCustom = ({ rule }: IProps): JSX.Element => {
  const {
    Custom5,
    Custom6,
    Custom7,
    Custom8,
    Custom9,
    Custom10,
    Custom11,
    Custom12,
    Custom13,
    Custom14,
    Custom15,
    Custom16,
    Custom17,
    Custom18,
  } = rule;
  return (
    <Rows gap={spacing.small}>
      <Row noPadding>
        <Cols gap={spacing.extraSmall} style={{ alignItems: 'center' }}>
          <Col displayFlex>
            <IconV2 name='edit' small />
          </Col>
          <Col>
            <Text small bold tKey='Custom' singleLineLabel />
          </Col>
        </Cols>
      </Row>
      <Row largeHorizontalPadding noVerticalPadding>
        <Cols
          wrap
          gap={spacing.medium}
          style={{
            alignItems: 'flex-start',
          }}
        >
          {/* Custom fields - only render if value exists */}
          {Custom5 && <ColKeyValuePair tKey='Custom5' value={formatCommaSeparated(Custom5)} />}
          {Custom6 && <ColKeyValuePair tKey='Custom6' value={formatCommaSeparated(Custom6)} />}
          {Custom7 && <ColKeyValuePair tKey='Custom7' value={formatCommaSeparated(Custom7)} />}
          {Custom8 && <ColKeyValuePair tKey='Custom8' value={formatCommaSeparated(Custom8)} />}
          {Custom9 && <ColKeyValuePair tKey='Custom9' value={formatCommaSeparated(Custom9)} />}
          {Custom10 && <ColKeyValuePair tKey='Custom10' value={formatCommaSeparated(Custom10)} />}
          {Custom11 && <ColKeyValuePair tKey='Custom11' value={formatCommaSeparated(Custom11)} />}
          {Custom12 && <ColKeyValuePair tKey='Custom12' value={formatCommaSeparated(Custom12)} />}
          {Custom13 && <ColKeyValuePair tKey='Custom13' value={formatCommaSeparated(Custom13)} />}
          {Custom14 && <ColKeyValuePair tKey='Custom14' value={formatCommaSeparated(Custom14)} />}
          {Custom15 && <ColKeyValuePair tKey='Custom15' value={formatCommaSeparated(Custom15)} />}
          {Custom16 && <ColKeyValuePair tKey='Custom16' value={formatCommaSeparated(Custom16)} />}
          {Custom17 && <ColKeyValuePair tKey='Custom17' value={formatCommaSeparated(Custom17)} />}
          {Custom18 && <ColKeyValuePair tKey='Custom18' value={formatCommaSeparated(Custom18)} />}
        </Cols>
      </Row>
    </Rows>
  );
};
